var map = {
	"./IIP_logo.png": "300e",
	"./alpaca.jpg": "0812",
	"./bema/bema_logo.png": "aca9",
	"./bema/favicon.png": "94cab",
	"./bema/mt_logo.png": "32c2",
	"./bema/thumbnail_B Favicon 16 .png": "5b45",
	"./bema/thumbnail_BEMA Color.png": "165e",
	"./iip/IIP_logo.png": "c89e",
	"./iip/logo.png": "13c8",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";